import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://assets.auxodev.dk/assets/f1317603-54a7-41be-bffe-0256114ce69f/45b5a6a5-f98a-4fbf-b31e-955992c09141.jpg"
          alt="Premium Car Detailing"
          className="w-full h-full object-cover object-center scale-105 animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black" />
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-bold tracking-[0.3em] uppercase bg-white/10 backdrop-blur-md border border-white/20 rounded-full">
            Velkommen til MJ Detailing
          </span>
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-black tracking-normal mb-8 leading-[1.1]">
            PROFESSIONEL BILPLEJE <br />
            <span className="bg-linear-to-r from-zinc-500 via-white to-zinc-500 bg-[length:200%_auto] bg-clip-text text-transparent animate-shine">
              MED FOKUS PÅ PERFEKTION
            </span>
          </h1>
          <p className="text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto mb-12 leading-relaxed">
            Eksklusiv rengøring, polering og coating med fokus på glans, kvalitet og langtidsholdbar beskyttelse.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="group flex items-center gap-2 bg-white text-black px-7 py-3.5 rounded-full text-lg font-bold hover:bg-zinc-200 transition-all w-full sm:w-auto justify-center"
            >
              Få Et Tilbud
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/ydelser/rengoering"
              className="flex items-center justify-center px-7 py-3.5 rounded-full text-lg font-bold border border-white/20 hover:bg-white/10 transition-all w-full sm:w-auto"
            >
              Se Vores Ydelser
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-[bounce_2s_infinite]"
      >
        <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-zinc-500 to-transparent" />
      </motion.div>
    </section>
  );
}
